import React from "react";
import "./News_Modal.css"
import { Modal } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function News_Modal({data,IMG_URL, ...props }) {
  // 🔹 Event Card Data Array
  const newsData = [
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
    {
      imgSrc: "/assest/luxury_images/in_company/event/event_card/event.png",
      cardHeading: "Mittal Group at Shotshow 2023",
    },
  ];


  return (
    <>
      <section className="Event_Modal_hodler News_Modal_holder common_modal_holder">
        <Modal
          {...props}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="Event_Modal News_Modal common_modal"
        >
          <Modal.Body>
            <div className="close_icon_holder" onClick={props.onHide}>
              <FontAwesomeIcon className="close_icon" icon={faCircleXmark} />
            </div>
         

            <div className="swiper_all_img_holder">
              <Swiper
                spaceBetween={0}
                slidesPerView={1}
                 modules={[Navigation]}
                navigation
                className="Img_swiper common_swiper "
              >
                {data?.news_images?.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="img_holder">
                      <img src={IMG_URL+item.image} alt="event" className="news_img" />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default News_Modal;
